var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.84 48.9"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.14 18.31H12.88v12.28h10.26v8.72l18.55-14.8h.15l-.08-.06.08-.06h-.15L23.14 9.58zM14.85 0h-13A1.83 1.83 0 000 1.82v45.26a1.83 1.83 0 001.82 1.82h14.82v-3.51H5.46a1.83 1.83 0 01-1.82-1.82V5.3a1.83 1.83 0 011.82-1.83h11.2V0z",
    fill: "#999",
    "data-name": "Layer 1"
  }))));
}
export default SvgLastSession;